"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPrm = exports.genPrmString = void 0;
var ezspm_1 = require("./ezspm");
var url_1 = require("./url");
function genPrmString(params) {
    var _a = params.site, site = _a === void 0 ? "1" : _a, _b = params.page, page = _b === void 0 ? "65" : _b, part = params.part, _c = params.content, content = _c === void 0 ? 0 : _c;
    return site + "." + page + "." + part + "." + content;
}
exports.genPrmString = genPrmString;
var sendPrm = function (params) {
    ezspm_1.doRequest("https://i.ezbuy.sg/FrFrR9Yl2HaDMiDnVkA3ISYJI_hf?" + url_1.convertParams({
        prm: genPrmString(params),
        ver: +new Date(),
    }));
};
exports.sendPrm = sendPrm;
